import { z } from 'zod';
/**
 * Tipos y schemas compartidos por la PWA, la API y el sitio publico.
 * Los nombres siguen literalmente §4.1 del documento de arquitectura.
 *
 * Este archivo es el minimo de T01. El modelo completo lo cierran
 * T02 (packages/db) y T03 (motor de disponibilidad).
 */
/** UUIDv7 generado en la aplicacion, nunca por la base (§2, principio "IDs"). */
export const idSchema = z.uuid();
/** §4.2 — ciclo de vida de la cita. `tentativa_local` es exclusivo del cliente offline (§5.3). */
export const estadoCitaSchema = z.enum([
    'tentativa_local',
    'pendiente',
    'confirmada',
    'en_atencion',
    'atendida',
    'facturada',
    'cancelada',
    'no_asistio',
    'pendiente_reprogramar',
]);
/** §4.2 — de donde vino la cita. Sirve para medir cuanto aporta la reserva publica. */
export const origenCitaSchema = z.enum(['recepcion', 'publico', 'whatsapp', 'profesional']);
/** §3.5 — afinidad recurso-espacio. */
export const modoAfinidadSchema = z.enum(['fijo', 'preferido']);
/** §6.2 — un cargo cubierto por seguro queda con pago pendiente de tercero. */
export const pagadorTipoSchema = z.enum(['paciente', 'tercero']);
/** §6.1.1 — modalidad del acuerdo de uso de los profesionales invitados. */
export const modalidadAcuerdoSchema = z.enum([
    'alquiler_fijo',
    'porcentaje_produccion',
    'por_hora',
    'por_sillon',
]);
/** §2.1 — feature flags por tenant. Un solo codigo, un solo despliegue. */
export const flagSchema = z.enum([
    'pack_odonto',
    'sifen',
    'reserva_publica',
    'whatsapp',
    'liquidacion',
]);
/** §3.4 — granularidad de la agenda. Default 15 minutos, configurable por tenant. */
export const slotMinSchema = z.int().positive().max(240);
export const SLOT_MIN_DEFAULT = 15;
/** Zona operativa. Nunca se almacena hora local: solo se convierte en los bordes de presentacion. */
export const ZONA_OPERATIVA = 'America/Asuncion';
//# sourceMappingURL=comunes.js.map